import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-local';

export default function Example() {
  return (
    <>
      <Head>
        <title>What You Need To Know To Sell and Earn More With Mercari Local</title>
        <meta
          name='description'
          content='Learn how to boost your sales locally and earn faster by using Mercari Local to get your items delivered on the same day and get people to notice your business.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-local' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-local' />
        <meta property='og:title' content='What You Need To Know To Sell and Earn More With Mercari Local' />
        <meta
          property='og:description'
          content='Learn how to boost your sales locally and earn faster by using Mercari Local to get your items delivered on the same day and get people to notice your business.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 14th, 2022' />
        <meta property='article:modified_time' content='April 14th, 2022' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
